interface QuickAnswerProps {
  /** The short, quotable answer. 2–3 sentences. */
  text: string;
  heading?: string;
  className?: string;
}

/**
 * "Kurzantwort" — a short, self-contained answer directly under the H1.
 * Rendered server-side so search engines and AI answer engines can quote it
 * without executing JavaScript.
 */
export function QuickAnswer({ text, heading = "Kurzantwort", className = "" }: QuickAnswerProps) {
  return (
    <section
      aria-label={heading}
      className={`rounded-xl border border-primary/20 bg-primary/5 p-5 ${className}`}
    >
      <h2 className="text-sm font-bold uppercase tracking-wide text-primary mb-2">{heading}</h2>
      <p className="text-gray-800 leading-relaxed">{text}</p>
    </section>
  );
}
